import { default as Box } from '@mui/material/Box';
import { ContentCard } from 'components/Card';
import { getTrans } from 'modules/i18n';
import { EditModeNavigationButtons } from '../../components/EditModeNavigationButtons';
import { PreviousStepNavigationButton } from '../../components/PreviousStepNavigationButton';
import { StepNavigationButton } from '../../components/StepNavigationButton';
import { StepProgressIndicator } from '../../components/StepProgressIndicator';
import { RootBox } from '../../components/styledComponents';
import { useEditModeNavigation } from '../../hooks/useEditModeNavigation';
import { PersonalDetailsForm } from './PersonalDetailsForm';

export const PersonalDetailsStep = () => {
  const { isEditMode } = useEditModeNavigation();

  if (isEditMode) {
    return (
      <RootBox>
        <ContentCard
          title={getTrans('cvBuilderPage.personalDetails.title')}
          titleVariant="h4"
        >
          <Box sx={{ mb: 2 }}>
            <StepProgressIndicator
              showPercentage={true}
              size="medium"
              variant="compact"
            />
          </Box>
        </ContentCard>
        <PersonalDetailsForm />
        <EditModeNavigationButtons />
      </RootBox>
    );
  }

  return (
    <RootBox>
      <ContentCard
        title={getTrans('cvBuilderPage.personalDetails.title')}
        titleVariant="h4"
      >
        <Box sx={{ mb: 2 }}>
          <StepProgressIndicator
            showPercentage={true}
            size="medium"
            variant="compact"
          />
        </Box>
      </ContentCard>
      <PersonalDetailsForm />

      <Box sx={{ flex: 1 }} />
      <StepNavigationButton step="PERSONAL_DETAILS" />
      <PreviousStepNavigationButton step="PERSONAL_DETAILS" />
    </RootBox>
  );
};
